import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export type MenuItemProp = {
    className?: string;
    icon: React.ReactNode;
    name: string;
    /** Navigation target. Omit and pass onClick for actions such as logout. */
    link?: string;
    onClick?: () => void;
}

export type DropdownMenuProps = {
    children: React.ReactNode;
    menus: Array<MenuItemProp>;
    triggerClassName?: string;
}

const DropdownMenu = (props: DropdownMenuProps) => {
    return (
        <Menu>
            <MenuButton
                className={twMerge(
                    "flex items-center space-x-3",
                    props.triggerClassName
                )}
            >
                {props.children}
            </MenuButton>

            <MenuItems
                transition
                anchor="bottom end"
                className="z-20 min-w-56 origin-top-right rounded-xl border border-zinc-100 bg-white p-2 text-sm/6 shadow-lg transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
            >
                {props.menus.map((el) => (
                    <MenuItem key={el.name}>
                        {el.link ? (
                            <Link
                                to={el.link}
                                className={twMerge(
                                    "flex space-x-2 items-center px-2 py-1.5 rounded-md data-[focus]:bg-zinc-100",
                                    el.className
                                )}
                            >
                                {el.icon}
                                <span>{el.name}</span>
                            </Link>
                        ) : (
                            <button
                                type="button"
                                onClick={el.onClick}
                                className={twMerge(
                                    "w-full flex space-x-2 items-center px-2 py-1.5 rounded-md data-[focus]:bg-zinc-100",
                                    el.className
                                )}
                            >
                                {el.icon}
                                <span>{el.name}</span>
                            </button>
                        )}
                    </MenuItem>
                ))}
            </MenuItems>
        </Menu>
    );
};

export default DropdownMenu;
